import React, {FC, memo, useEffect, useState} from "react";
import {CheckOutlined, CloseOutlined} from "@ant-design/icons";
import {Button, Form} from "antd";
import moment from "moment";
import {blue, red} from "@ant-design/colors";
import classNames from "classnames";
import {ScheduledPaymentType} from "./PaymentsInteractive";
import css from "./PaymentLists.less";
import {renderAmount} from "../../../../helpers/renderAmount";
import {Currency} from "../../../../generated/graphql";
import {useCurrency} from "../../../../helpers/currencyHelper";
import MoneyInput from "../../../../views/MoneyInput/MoneyInput";
import LayoutForm from "../../../../views/LayoutForm/LayoutForm";
import DateInput from "../../../../views/DateInput/DateInput";

const FormItem = Form.Item;

type EditPaymentViewProps = {
    // payment: ScheduledPaymentSimpleInput;
    // rowIndex: number;
    // onSave: (payment: ScheduledPaymentSimpleInput, rowIndex: number) => void;
    onCancel: (rate: ScheduledPaymentType) => void;
    onSave: (rate: ScheduledPaymentType, rowIndex: number) => void;
    // loading: boolean;
    rate: ScheduledPaymentType;
    rowIndex: number;
};

const EditPaymentView: FC<EditPaymentViewProps> = ({rate, rowIndex, onCancel, onSave}) => {
    const currency = useCurrency();
    const [paymentDue, setPaymentDue] = useState<Date>(rate.paymentDue);
    const [paymentAmount, setPaymentAmount] = useState<number>(rate.paymentAmount ?? 0);
    const momentDate = moment(paymentDue);

    const handleSave = () => {
        const newPayment = {
            ...rate,
            paymentAmount,
            paymentDue,
        };

        onSave(newPayment, rowIndex);
    };

    useEffect(() => {
        console.log("Rate geändert:", rate);
        setPaymentAmount(rate.paymentAmount ?? 0);
        setPaymentDue(rate.paymentDue);
    }, [rate]);

    // console.log("rate", rate);

    return (
        <div key={rate.id} className={classNames(css.monthlyPaymentEntry, css.monthlyPaymentEntryEditView)}>
            <LayoutForm className={css.main} layout="vertical" columns={1}>
                <FormItem
                    label={
                        <div /* className={css.month} */>
                            <span className={css.num}>{`${rowIndex + 1}.`}</span>
                            <span>{moment(rate.paymentDue).format("MMM YY")}</span>
                        </div>
                    }
                    className={css.month}
                >
                    <DateInput
                        value={momentDate.isValid() ? momentDate : undefined}
                        allowClear={false}
                        onChange={(value) => setPaymentDue(value?.toDate() ?? new Date())}
                        style={{width: "100%"}}
                        displayFormat="DD.MM.YYYY"
                    />
                </FormItem>
                <FormItem
                    className={css.amount}
                    name="paymentAmount"
                    label={
                        <div /* className={css.amount} */>
                            {renderAmount({
                                amount: rate.paymentAmount ?? 0,
                                currency: currency.short as Currency,
                            })}
                        </div>
                    }
                >
                    {/* Füge Debug-Informationen im DOM hinzu */}
                    <div style={{display: "none"}}>
                        {"Debug: amount="}
                        {paymentAmount}
                        {", type="}
                        {typeof paymentAmount}
                    </div>
                    <MoneyInput
                        key={`money-input-${rate.id}`}
                        defaultValue={paymentAmount}
                        value={paymentAmount}
                        onChange={(value) =>
                            setPaymentAmount(value !== undefined && value !== null ? Number(value) : 0)
                        }
                        // autoFocus
                    />
                </FormItem>
                <FormItem className={css.editButtons}>
                    <Button
                        // size="small"
                        type="default"
                        icon={<CloseOutlined />}
                        style={{color: red[3], borderColor: red[3]}}
                        onClick={() => onCancel(rate)}
                    />
                    <Button
                        // size="small"
                        type="primary"
                        icon={<CheckOutlined />}
                        // onClick={() => handleSave(rate, rowIndex)}
                        onClick={handleSave}
                    />
                </FormItem>
            </LayoutForm>
        </div>
    );
};

export default memo(EditPaymentView);
